import { gql } from '@apollo/client';

export const GET_FORM_STATUS = gql`
    query getFormStatus {
        isFormDirty @client
    }
`;
